"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _CreditTerms = require("./CreditTerms");
Object.keys(_CreditTerms).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CreditTerms[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CreditTerms[key];
    }
  });
});